export const planogramsEn = {
  pageTitle: "Active Planograms",
  pageSubtitle:
    "View and manage all active planograms across stores. Monitor performance metrics, review warnings, and track version history.",
  reports: "Reports",
  exports: "Exports",

  banner: {
    title: "Planogram Manager",
    description:
      "Monitor active planograms across all stores. Review layout performance, check compliance metrics, and address warnings. Click on a planogram ID to view version history.",
  },

  filters: {
    viewOn: "View on:",
    searchPlaceholder: "Search by store, ID...",
    filterPogs: "Filter store POGs by:",
    showAs: "Show as:",
    activeFilters: "Active filters:",
    clearAll: "Clear all",
    cluster: "Cluster",
    store: "Store",
    category: "Category",
    search: "Search",
  },

  results: {
    showing: "Showing {{filtered}} of {{total}} planograms",
    selected: "({{count}} selected)",
  },

  columns: {
    storeCode: "Store Code",
    storeStatus: "Status",
    templateId: "Template ID",
    activePlanogramId: "Planogram ID",
    returnOnSpace: "Return on Space",
    coreRange: "Core Range",
    shelfAlignment: "Shelf Alignment",
    dogms: "DOGMS",
    size: "Size",
    warnings: "Warnings",
    activeDate: "Active Date",
    endDate: "End Date",
    lastEdited: "Last Edited",
    actions: "Actions",
  },

  status: {
    pending: "Pending",
    active: "Active",
    inactive: "Inactive",
  },

  actions: {
    viewEdit: "View / Edit",
  },

  noResults: "No planograms found",

  warnings: {
    title: "Planogram Warnings",
    close: "Close",
    none: "No active warnings for this planogram",
    high: "High",
    medium: "Medium",
    low: "Low",
    types: {
      out_of_stock: "Out of Stock",
      misplacement: "Misplacement",
      shelf_compliance: "Shelf Compliance",
      product_rotation: "Product Rotation",
      price_tag: "Price Tag",
    },
  },

  history: {
    title: "Planogram History",
    approvedBy: "Approved by:",
    activated: "Activated:",
    deactivated: "Deactivated:",
    close: "Close",
    exportHistory: "Export History",
  },
} as const;

export type PlanogramsTranslations = typeof planogramsEn;
